/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentScheduleDto } from '../../models/enrollment-schedule-dto';

export interface EnrollmentScheduleControllerFindSupplementByIdV1$Params {
  id: string;
}

export function enrollmentScheduleControllerFindSupplementByIdV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerFindSupplementByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerFindSupplementByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrollmentScheduleDto>;
    })
  );
}

enrollmentScheduleControllerFindSupplementByIdV1.PATH = '/api/v1/enrollment-schedule/supplement/{id}';
